import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { KyrgyzstanEmpty, KyrgyzstanOfferCard } from 'entities/kyrgyzstan/ui'

import type { RealtyObject } from 'shared/api/kyrgyzstan/search'
import { SimpleLoader } from 'shared/ui/simple-loader'
import { Skeleton, SkeletonTheme } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const SkeletonItemsCount = 6

interface BestOffersGridProps {
  offers: RealtyObject[]
  isLoading: boolean
  error: string | null
  onOfferClick?: (id: string) => void
}

export const BestOffersGrid = ({
  offers,
  isLoading,
  error,
  onOfferClick,
}: BestOffersGridProps) => {
  const { t } = useTranslation()

  if (isLoading && offers.length === 0) {
    return (
      <div className={clsx('container', s.grid)}>
        {Array.from({ length: SkeletonItemsCount }).map((_, index) => (
          <SkeletonTheme
            key={index}
            baseColor="var(--grey-32)"
            highlightColor="var(--grey-33)"
          >
            <div className={s.skeletonItem}>
              <Skeleton className={s.skeletonItemImage} />
              <Skeleton className={s.skeletonItemTitle} />
            </div>
          </SkeletonTheme>
        ))}
      </div>
    )
  }

  if (error && offers.length === 0) {
    return (
      <KyrgyzstanEmpty
        title={t('kyrgyzstan_block.error.title')}
        subtitle={error}
      />
    )
  }

  if (offers.length === 0 && !isLoading) {
    return <KyrgyzstanEmpty title={t('kyrgyzstan_block.offers.empty')} />
  }

  const isLoadingPagination = offers.length > 0 && isLoading

  return (
    <>
      <div className={clsx('container', s.grid)}>
        {offers.map((offer) => (
          <KyrgyzstanOfferCard
            key={offer.id}
            id={offer.id}
            title={offer.title}
            images={offer.images}
            type={offer.type}
            price={parseInt(offer.price, 10) || 0}
            variant="grid"
            onClick={onOfferClick}
          />
        ))}
      </div>

      {isLoadingPagination && (
        <div className={clsx('container', s.paginationLoader)}>
          <SimpleLoader />
        </div>
      )}
    </>
  )
}
